"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_STATES = exports.APP_CONFIG = exports.APP_STORE = exports.APP_INIT = exports.APP_VAR = void 0;
exports.APP_VAR = '__APP__';
exports.APP_INIT = 'init';
exports.APP_STORE = 'store';
exports.APP_CONFIG = 'config';
exports.APP_STATES = 'states';
//# sourceMappingURL=vars.js.map